var map = {
	"./Group 3758.svg": "376f",
	"./InventoryHome.svg": "877f",
	"./about_video.svg": "1f24",
	"./arrow-left-white.svg": "c679",
	"./arrow-left.svg": "650c",
	"./arrow-right-white.svg": "1ce0",
	"./arrow-right.svg": "bfd6",
	"./better_control.svg": "7b43",
	"./bg-review.svg": "be69",
	"./blezux.svg": "a20a",
	"./blue_eye.svg": "c1e8",
	"./catalog_guide.svg": "929c",
	"./catalog_stores.svg": "91a6",
	"./cube_purple.svg": "0b0c",
	"./ealom.svg": "1c9c",
	"./founder.svg": "a00a",
	"./fullfill.svg": "4777",
	"./glossel.svg": "7721",
	"./guardan.svg": "a4f8",
	"./guide_order.svg": "a44f",
	"./guide_shipping.svg": "590e",
	"./home_1.svg": "ebf6",
	"./integrate.svg": "9ebe",
	"./inventoryHeader.svg": "7873",
	"./inventoryManagement.svg": "33b3",
	"./inventoryRight.svg": "9f0e",
	"./inventoryTrack.svg": "65d7",
	"./logoSite.svg": "00f7",
	"./openinigConnection.svg": "9294",
	"./orderManagementHeader.svg": "c73e",
	"./orderRight.svg": "c68e",
	"./payramax.svg": "fff4",
	"./perspective_matte .svg": "0b72",
	"./pickPack.svg": "8c27",
	"./productCatalogHeader.svg": "3ef9",
	"./product_analytic.svg": "6de5",
	"./questionTech.svg": "7ff2",
	"./sales.svg": "d1ce",
	"./scoprum.svg": "c6b4",
	"./searchsvg.svg": "9177",
	"./ship_management.svg": "fc40",
	"./shippingSoftwareHeader.svg": "4739",
	"./social_1.svg": "7a4e",
	"./social_2.svg": "cf57",
	"./social_3.svg": "c129",
	"./social_4.svg": "f581",
	"./technicalSupportLeft.svg": "f57a",
	"./technicalSupportRight.svg": "a70b",
	"./tick.svg": "24fb",
	"./tik.svg": "e145",
	"./upload_variety.svg": "d1eb",
	"./world.svg": "8a1a",
	"./yello_flag.svg": "9eff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e57c";